import { SubIndexCodes } from 'store/vibrancy/reducerSlice'
import { DataKey, MetricType } from '../types'

export * from './rankedColor'

export const DATA_FILE_PATH = '/data/'
// export const DATA_FILE_NAME = 'full_data_06.27.24'
export const DATA_FILE_NAME = 'full_data_10.28.24'
// export const DATA_FILE_NAME = 'full_data_07.22.24'
export const LEGEND_FILE_NAME = 'national_ai_strategy_by_status_over_time'
export const LEGEND_YEAR_FILE_NAME = 'national_ai_strategy_release_year'
// export const DATA_FILE_NAME = 'full_data_Apr2024'
export const CODEBOOK_FILE_PATH = '/data/'
export const CODEBOOK_FILE_NAME = 'codebook_06.27.24'
export const VARIABLE_LIST = 'variable_list_06.27.24'
// export const CODEBOOK_FILE_NAME = 'codebook_4'

export enum COLOR {
  LIGHT = '#e4e4e4',
  DARK = '#172E5C',
  TEXT = '#73D9FF',
  WHITE = '#FFFFFF',
  NAVY = '#041b33',
  NAVY2 = '#75c1e1',
  NAVY3 = '#3a80b7',
  BAR1 = 'rgba(58, 141, 199, 1)',
  BAR2 = 'rgba(36, 148, 153, 1)',
  BAR1LIGHT = 'rgba(58, 141, 199, 0.8)',
  BAR2LIGHT = 'rgba(36, 148, 153, 0.8)',
  CARRET = 'rgba(50, 115, 220, 1)',

  BAR3 = '#872996',
  BAR3LIGHT = '#87299680',
  BAR4 = '#89D0E5',
  BAR4LIGHT = '#89D0E580',
  BAR5 = '#eaadff',
  BAR5LIGHT = '#eaadff80',
  BAR6 = '#4d1f52',
  BAR6LIGHT = '#4d1f5280',
  BAR7 = '#9cf2f2',
  BAR7LIGHT = '#9cf2f280',
  BAR8 = '#172e5c',
  BAR8LIGHT = '#172e5c80',
}

export const GROUPING_LIST = [
  { displayName: 'Pillar', name: 'pillar', headerKey: 'Pillar' },
  { displayName: 'Region', name: 'region', headerKey: 'Region' },
  { displayName: 'Income Group', name: 'incomeGroup', headerKey: 'IncomeGroup' },
]

export const INCOME_GROUP_INFO = [
  {
    displayName: 'High Income',
    name: 'High income',
    color: 'rgba(12,107,113,255)',
    lightColor: 'rgba(12,107,113,0.8)',
  },
  {
    displayName: 'Upper Middle Income',
    name: 'Upper middle income',
    color: 'rgba(28,196,186,255)',
    lightColor: 'rgba(28,196,186,0.8)',
  },
  {
    displayName: 'Lower Middle Income',
    name: 'Lower middle income',
    color: 'rgba(235,172,255,255)',
    lightColor: 'rgba(235,172,255,0.8)',
  },
  {
    displayName: 'Low Income',
    name: 'Low Income',
    color: 'rgba(134,40,150,255)',
    lightColor: 'rgba(134,40,150,0.8)'
  },
]

export const REGION_INFO = [
  {
    displayName: 'East Asia & Pacific',
    name: 'East Asia & Pacific',
    color: 'rgba(235,172,255,255)',
    lightColor: 'rgba(235,172,255,0.8)',
  },
  {
    displayName: 'Europe & Central Asia',
    name: 'Europe & Central Asia',
    color: 'rgba(28,196,186,255)',
    lightColor: 'rgba(28,196,186,0.8)',
  },
  {
    displayName: 'Latin America & Caribbean',
    name: 'Latin America & Caribbean',
    color: 'rgba(115,216,254,255)',
    lightColor: 'rgba(115,216,254,0.8)',
  },
  {
    displayName: 'Middle East & North Africa',
    name: 'Middle East & North Africa',
    color: 'rgba(77,30,83,255)',
    lightColor: 'rgba(77,30,83,0.8)',
  },
  {
    displayName: 'North America',
    name: 'North America',
    color: 'rgba(28,120,186,255)',
    lightColor: 'rgba(28,120,186,0.8)',
  },
  { displayName: 'South Asia', name: 'South Asia', color: 'rgba(199,93,215,255)', lightColor: 'rgba(199,93,215,0.8)' },
  {
    displayName: 'Sub-Saharan Africa',
    name: 'Sub-Saharan Africa',
    color: 'rgba(28,75,78,255)',
    lightColor: 'rgba(28,75,78,0.8)',
  },
]

export const NUMBER_OF_YEAR_IN_REPORT = 2

export type PillarType = Record<string, string | number> & {
  displayName: string
  name: string
  color: string
  lightColor: string
  dataKey: DataKey
  metricType: MetricType
  defaultMultiplier: number
}

export type Indicators = {
  metricName: string,
  metricDataKey: string,
  shortname_raw: string,
  shortname_scale: string,
  shortname_raw_pc: string,
  shortname_scale_pc: string
}

export interface SubIndicesData {
  indexName: string;
  indexCode: SubIndexCodes;
  pillarList: string[];
  indicators: Indicators[];
  description: string;
}

export const PILLAR_INFO: PillarType[] = [
  {
    // displayName: 'R&D',
    displayName: 'R&D',
    // name: 'Research and Development', // Old code book
    name: 'R&D', // New code book 27.06.2024
    color: COLOR.BAR1,
    lightColor: COLOR.BAR1LIGHT,
    dataKey: 'research',
    metricType: 'rad',
    defaultMultiplier: 1,
  },
  {
    // displayName: 'RESPONSIBLE AI',
    displayName: 'Responsible AI',
    name: 'Responsible AI',
    color: COLOR.BAR3,
    lightColor: COLOR.BAR3LIGHT,
    dataKey: 'responsible',
    metricType: 'rai',
    defaultMultiplier: 0.2,
  },
  {
    // displayName: 'ECONOMY',
    displayName: 'Economy',
    name: 'Economy',
    color: COLOR.BAR2,
    lightColor: COLOR.BAR2LIGHT,
    dataKey: 'economy',
    metricType: 'eco',
    defaultMultiplier: 0.8,
  },

  {
    // displayName: 'EDUCATION',
    displayName: 'Education',
    name: 'Education',
    color: COLOR.BAR4,
    lightColor: COLOR.BAR4LIGHT,
    dataKey: 'education',
    metricType: 'edu',
    defaultMultiplier: 0.2,
  },
  {
    // displayName: 'DIVERSITY',
    displayName: 'Diversity',
    name: 'Diversity',
    color: COLOR.BAR5,
    lightColor: COLOR.BAR5LIGHT,
    dataKey: 'diversity',
    metricType: 'div',
    defaultMultiplier: 0.1,
  },
  {
    // displayName: 'POLICY AND GOVERNANCE',
    displayName: 'Policy and Governance',
    name: 'Policy and Governance',
    color: COLOR.BAR6,
    lightColor: COLOR.BAR6LIGHT,
    dataKey: 'policy',
    metricType: 'pol',
    defaultMultiplier: 0.4,
  },
  {
    // displayName: 'PUBLIC OPINION',
    displayName: 'Public Opinion',
    name: 'Public Opinion',
    lightColor: COLOR.BAR7LIGHT,
    color: COLOR.BAR7,
    dataKey: 'publicOpinion',
    metricType: 'pub',
    defaultMultiplier: 0.2,
  },
  {
    // displayName: 'INFRASTRUCTURE',
    displayName: 'Infrastructure',
    name: 'Infrastructure',
    lightColor: COLOR.BAR8LIGHT,
    color: COLOR.BAR8,
    dataKey: 'infrastructure',
    metricType: 'inf',
    defaultMultiplier: 0.6,
  },
]

export const METRIC_DEFAULT_MULTIPLIER = {
  'AI Journal Publications': 8,
  'AI Journal Citations': 8,
  'AI Conference Publications': 6,
  'AI Conference Citations': 7,
  'AI Patent Grants': 8,
  'Notable Machine Learning Models': 9,
  'Academia-Industry Model Production Concentration': 0,
  'Foundation Models': 3,
  'Foundation Models Datasets': 3,
  'Foundation Models Applications': 3,
  'Open Access Foundation Models': 0,
  'AI GitHub Projects': 7,
  'AI GitHub Projects Stars': 8,
  'FAccT Conference Submissions on RAI Topics': 7,
  'NeurIPS Conference Submissions on RAI Topics': 10,
  'ICML Conference Submissions on RAI Topics': 8,
  'ICLR Conference Submissions on RAI Topics': 7,
  'AIES Conference Submissions on RAI Topics': 6,
  'AAAI Conference Submissions on RAI Topics': 8,
  'Total AI Private Investment': 10,
  'Total AI Merger/Acquisition Investment': 9,
  'Total AI Minority Stake Investment': 7,
  'Total AI Public Offering Investment': 7,
  'Newly Funded AI Companies': 9,
  'AI Hiring Rate YoY Ratio': 6,
  'Relative AI Skill Penetration': 3,
  'AI Talent Concentration': 6,
  'AI Job Postings (% of Total)': 0,
  'Net Migration Flow of AI Skills': 6,
  'AI Study Programs in English': 6,
  'AI Study Programs in English Penetration': 7,
  'AI Talent Concentration Gender Equality Index': 10,
  'National AI Strategy Presence': 10,
  'AI Legislation Passed': 10,
  'AI Mentions in Legislative Proceedings': 6,
  'Social Media Share of Voice on AI': 8,
  'AI Social Media Posts': 6,
  'AI-Related Social Media Conversations Net Sentiment': 9,
  'Parts Semiconductor Devices Exports': 10,
  'Supercomputers': 9,
  'Compute Capacity (Rmax)': 10,
  'Internet Speed': 8,
}

export const DOWNLOAD_FILE_NAME = {
  aiMetricOverTime: 'AI-metric-over-time-bar',
  aiMetricOverTimeWorldMap: 'AI-metric-over-time-worldmap',
  globalAiVibrancyRankingBar: 'Global-AI-vibrancy-ranking-bar',
  nationalAiVibrancyRankingBar: 'National-AI-vibrancy-ranking-bar',
  globalAiVibrancyRankingTable: 'Global-AI-vibrancy-ranking-table',
  countryReport: 'Country-report',
  slopeChart: 'Global-AI-vibrancy-slope-chart',
  subIndicesChart: {
    II: "Innovation-index",
    ECI: "Economic-competitive-index",
    PGPEI: "Policy-governance-and-public-engagement-index"
  }
}

export const METRIC_ENDPOINT_WEIGHT = '_weight'
export const METRIC_ENDPOINT_RANK = '_rank'

export const COVERAGE_RANGES = [
  {
    color: '#E7E7E7',
    title: 'No data',
  },
  {
    color: '#79CCEC',
    title: '0–75%',
  },
  {
    color: '#428BC5',
    title: '76–85%',
  },
  {
    color: '#132E69',
    title: '86–100%',
  },
]

export const BAR_CHART_DOMAIN_RANGES = [
  0.0005, 0.001, 0.005, 0.01, 0.5, 1, 2, 3, 5, 10, 20, 30, 40, 50, 60, 70, 80, 100, 150, 200, 250, 300, 400, 500, 700,
  1000, 2000, 3500, 5000, 6000, 7000, 15000, 20000, 40000, 45000,
]

export const BAR_CHART_TICK_RANGES = (isSmaller600: boolean) => [
  { max: 0.0005, ticks: [0, 0.0001, 0.0002, 0.0003, 0.0004, 0.0005] },
  { max: 0.001, ticks: [0, 0.0005, 0.001] },
  { max: 0.005, ticks: [0, 0.001, 0.002, 0.003, 0.004, 0.005] },
  { max: 0.01, ticks: [0, 0.005, 0.01] },
  { max: 0.5, ticks: [0, 0.1, 0.2, 0.3, 0.4, 0.5] },
  { max: 1, ticks: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] },
  { max: 2, ticks: [0, 0.5, 1, 1.5, 2] },
  { max: 3, ticks: [0, 1, 2, 3] },
  { max: 5, ticks: Array.from({ length: 6 }, (_, i) => i) },
  { max: 10, ticks: Array.from({ length: 11 }, (_, i) => i) },
  { max: 20, ticks: Array.from({ length: 5 }, (_, i) => i * 5) },
  { max: 30, ticks: Array.from({ length: 7 }, (_, i) => i * 5) },
  { max: 40, ticks: Array.from({ length: 9 }, (_, i) => i * 5) },
  { max: 50, ticks: Array.from({ length: 11 }, (_, i) => i * 5) },
  { max: 60, ticks: Array.from({ length: 7 }, (_, i) => i * 10) },
  { max: 70, ticks: Array.from({ length: 8 }, (_, i) => i * 10) },
  { max: 80, ticks: Array.from({ length: 9 }, (_, i) => i * 10) },
  { max: 100, ticks: Array.from({ length: 11 }, (_, i) => i * 10) },
  { max: 150, ticks: Array.from({ length: 7 }, (_, i) => i * 25) },
  { max: 200, ticks: Array.from({ length: 9 }, (_, i) => i * 25) },
  { max: 250, ticks: Array.from({ length: 6 }, (_, i) => i * 50) },
  { max: 300, ticks: Array.from({ length: 7 }, (_, i) => i * 50) },
  { max: 400, ticks: Array.from({ length: 9 }, (_, i) => i * 50) },
  { max: 500, ticks: Array.from({ length: 11 }, (_, i) => i * 50) },
  { max: 700, ticks: Array.from({ length: 8 }, (_, i) => i * 100) },
  { max: 1000, ticks: Array.from({ length: 6 }, (_, i) => i * 200) },
  { max: 2000, ticks: Array.from({ length: 5 }, (_, i) => i * 500) },
  { max: 3500, ticks: Array.from({ length: 8 }, (_, i) => i * 500) },
  { max: 5000, ticks: Array.from({ length: isSmaller600 ? 6 : 11 }, (_, i) => i * (isSmaller600 ? 1000 : 500)) },
  { max: 6000, ticks: Array.from({ length: 7 }, (_, i) => i * 1000) },
  { max: 7000, ticks: Array.from({ length: 8 }, (_, i) => i * 1000) },
  { max: 15000, ticks: Array.from({ length: 4 }, (_, i) => i * 5000) },
  { max: 20000, ticks: Array.from({ length: 5 }, (_, i) => i * 5000) },
  { max: 40000, ticks: Array.from({ length: 9 }, (_, i) => i * 5000) },
  { max: 45000, ticks: Array.from({ length: isSmaller600 ? 4 : 10 }, (_, i) => i * (isSmaller600 ? 15000 : 5000)) },
]

export const PDF_WIDTH = 210.0015555555555
export const SCALE_VALUE = 1.8
export const AIOT_ODD_CASE = ['national_ai_strategy_is_released', 'pc_national_ai_strategy_is_released']
export const II_SUB_INDEX_INDICATORS: Indicators[] = [
  {
    metricName: 'AI Journal Publications',
    metricDataKey: 'research',
    shortname_raw: 'number_of_total_journal_publications',
    shortname_scale: "norm_number_of_total_journal_publications",
    shortname_raw_pc: "pc_number_of_total_journal_publications",
    shortname_scale_pc: "norm_pc_number_of_total_journal_publications"
  },
  {
    metricName: 'AI Journal Citations',
    metricDataKey: 'research',
    shortname_raw: 'number_of_total_journal_citations',
    shortname_scale: "norm_number_of_total_journal_citations",
    shortname_raw_pc: "pc_number_of_total_journal_citations",
    shortname_scale_pc: "norm_pc_number_of_total_journal_citations"
  },
  {
    metricName: 'AI Conference Publications',
    metricDataKey: 'research',
    shortname_raw: 'number_of_total_conference_publications',
    shortname_scale: "norm_number_of_total_conference_publications",
    shortname_raw_pc: "pc_number_of_total_conference_publications",
    shortname_scale_pc: "norm_pc_number_of_total_conference_publications"
  },
  {
    metricName: 'AI Conference Citations',
    metricDataKey: 'research',
    shortname_raw: 'number_of_total_conference_citations',
    shortname_scale: "norm_number_of_total_conference_citations",
    shortname_raw_pc: "pc_number_of_total_conference_citations",
    shortname_scale_pc: "norm_pc_number_of_total_conference_citations"
  },
  {
    metricName: 'AI Patent Grants',
    metricDataKey: 'research',
    shortname_raw: 'number_of_total_patent_grants',
    shortname_scale: "norm_number_of_total_patent_grants",
    shortname_raw_pc: "pc_number_of_total_patent_grants",
    shortname_scale_pc: "norm_pc_number_of_total_patent_grants"
  },
  {
    metricName: 'Notable Machine Learning Models',
    metricDataKey: 'research',
    shortname_raw: 'number_of_notable_ml_models',
    shortname_scale: "norm_number_of_notable_ml_models",
    shortname_raw_pc: "pc_number_of_notable_ml_models",
    shortname_scale_pc: "norm_pc_number_of_notable_ml_models"
  },
  {
    metricName: 'Foundation Models',
    metricDataKey: 'research',
    shortname_raw: 'number_of_foundation_models',
    shortname_scale: "norm_number_of_foundation_models",
    shortname_raw_pc: "pc_number_of_foundation_models",
    shortname_scale_pc: "norm_pc_number_of_foundation_models"
  },
  {
    metricName: 'Foundation Models Datasets',
    metricDataKey: 'research',
    shortname_raw: 'number_of_foundation_models_datasets',
    shortname_scale: "norm_number_of_foundation_models_datasets",
    shortname_raw_pc: "pc_number_of_foundation_models_datasets",
    shortname_scale_pc: "norm_pc_number_of_foundation_models_datasets"
  },
  {
    metricName: 'Foundation Models Applications',
    metricDataKey: 'research',
    shortname_raw: 'number_of_foundation_models_applications',
    shortname_scale: "norm_number_of_foundation_models_applications",
    shortname_raw_pc: "pc_number_of_foundation_models_applications",
    shortname_scale_pc: "norm_pc_number_of_foundation_models_applications"
  },
  {
    metricName: 'AI GitHub Projects',
    metricDataKey: 'research',
    shortname_raw: 'number_of_github_repos',
    shortname_scale: "norm_number_of_github_repos",
    shortname_raw_pc: "pc_number_of_github_repos",
    shortname_scale_pc: "norm_pc_number_of_github_repos"
  },
  {
    metricName: 'AI GitHub Projects Stars',
    metricDataKey: 'research',
    shortname_raw: 'number_of_github_stars',
    shortname_scale: "norm_number_of_github_stars",
    shortname_raw_pc: "pc_number_of_github_stars",
    shortname_scale_pc: "norm_pc_number_of_github_stars"
  },
  {
    metricName: 'Parts Semiconductor Devices Exports',
    metricDataKey: 'infrastructure',
    shortname_raw: 'parts_semiconductor_devices_export_value',
    shortname_scale: "norm_parts_semiconductor_devices_export_value",
    shortname_raw_pc: "pc_parts_semiconductor_devices_export_value",
    shortname_scale_pc: "norm_pc_parts_semiconductor_devices_export_value"
  },
  {
    metricName: 'Supercomputers',
    metricDataKey: 'infrastructure',
    shortname_raw: 'number_of_supercomputers',
    shortname_scale: "norm_number_of_supercomputers",
    shortname_raw_pc: "pc_number_of_supercomputers",
    shortname_scale_pc: "norm_pc_number_of_supercomputers"
  },
  {
    metricName: 'Compute Capacity (Rmax)',
    metricDataKey: 'infrastructure',
    shortname_raw: 'compute_capacity_rmax_gflops',
    shortname_scale: "norm_compute_capacity_rmax_gflops",
    shortname_raw_pc: "pc_compute_capacity_rmax_gflops",
    shortname_scale_pc: "norm_pc_compute_capacity_rmax_gflops"
  },
  {
    metricName: 'Internet Speed',
    metricDataKey: 'infrastructure',
    shortname_raw: 'internet_speed_median_download_mbps',
    shortname_scale: "norm_internet_speed_median_download_mbps",
    shortname_raw_pc: "pc_internet_speed_median_download_mbps",
    shortname_scale_pc: "norm_pc_internet_speed_median_download_mbps"
  }
]
export const ECI_SUB_INDEX_INDICATORS: Indicators[] = [
  {
    metricName: 'Total AI Private Investment',
    metricDataKey: 'economy',
    shortname_raw: 'private_investment',
    shortname_scale: "norm_private_investment",
    shortname_raw_pc: "pc_private_investment",
    shortname_scale_pc: "norm_pc_private_investment"
  },
  {
    metricName: 'Total AI Merger/Acquisition Investment',
    metricDataKey: 'economy',
    shortname_raw: 'merger_acquisition_investment',
    shortname_scale: "norm_merger_acquisition_investment",
    shortname_raw_pc: "pc_merger_acquisition_investment",
    shortname_scale_pc: "norm_pc_merger_acquisition_investment"
  },
  {
    metricName: 'Total AI Minority Stake Investment',
    metricDataKey: 'economy',
    shortname_raw: 'minority_stake_investment',
    shortname_scale: "norm_minority_stake_investment",
    shortname_raw_pc: "pc_minority_stake_investment",
    shortname_scale_pc: "norm_pc_minority_stake_investment"
  },
  {
    metricName: 'Total AI Public Offering Investment',
    metricDataKey: 'economy',
    shortname_raw: 'public_offering_investment',
    shortname_scale: "norm_public_offering_investment",
    shortname_raw_pc: "pc_public_offering_investment",
    shortname_scale_pc: "norm_pc_public_offering_investment"
  },
  {
    metricName: 'Newly Funded AI Companies',
    metricDataKey: 'economy',
    shortname_raw: 'number_of_newly_funded_companies',
    shortname_scale: "norm_number_of_newly_funded_companies",
    shortname_raw_pc: "pc_number_of_newly_funded_companies",
    shortname_scale_pc: "norm_pc_number_of_newly_funded_companies"
  },
  {
    metricName: 'AI Hiring Rate YoY Ratio',
    metricDataKey: 'economy',
    shortname_raw: 'relative_ai_hiring_rate_yoy_ratio',
    shortname_scale: "norm_relative_ai_hiring_rate_yoy_ratio",
    shortname_raw_pc: "-",
    shortname_scale_pc: "-"
  },
  {
    metricName: 'Relative AI Skill Penetration',
    metricDataKey: 'economy',
    shortname_raw: 'relative_ai_skills_penetration',
    shortname_scale: "norm_relative_ai_skills_penetration",
    shortname_raw_pc: "-",
    shortname_scale_pc: "-"
  },
  {
    metricName: 'AI Talent Concentration',
    metricDataKey: 'economy',
    shortname_raw: 'ai_talent_concentration',
    shortname_scale: "norm_ai_talent_concentration",
    shortname_raw_pc: "pc_ai_talent_concentration",
    shortname_scale_pc: "norm_pc_ai_talent_concentration"
  },
  {
    metricName: 'Net Migration Flow of AI Skills',
    metricDataKey: 'economy',
    shortname_raw: 'net_migration_flow_ai_skills_per_10k',
    shortname_scale: "norm_net_migration_flow_ai_skills_per_10k",
    shortname_raw_pc: "pc_net_migration_flow_ai_skills_per_10k",
    shortname_scale_pc: "norm_pc_net_migration_flow_ai_skills_per_10k"
  }
]
export const PGPEI_SUB_INDEX_INDICATORS: Indicators[] = [
  {
    metricName: 'National AI Strategy Presence',
    metricDataKey: 'policy',
    shortname_raw: 'national_ai_strategy_is_released',
    shortname_scale: "norm_national_ai_strategy_is_released",
    shortname_raw_pc: "pc_national_ai_strategy_is_released",
    shortname_scale_pc: "norm_pc_national_ai_strategy_is_released"
  },
  {
    metricName: 'AI Legislation Passed',
    metricDataKey: 'policy',
    shortname_raw: 'num_ai_related_bills_passed',
    shortname_scale: "norm_num_ai_related_bills_passed",
    shortname_raw_pc: "pc_num_ai_related_bills_passed",
    shortname_scale_pc: "norm_pc_num_ai_related_bills_passed"
  },
  {
    metricName: 'AI Mentions in Legislative Proceedings',
    metricDataKey: 'policy',
    shortname_raw: 'ai_mentions_in_legislative_proceedings',
    shortname_scale: "norm_ai_mentions_in_legislative_proceedings",
    shortname_raw_pc: "pc_ai_mentions_in_legislative_proceedings",
    shortname_scale_pc: "norm_pc_ai_mentions_in_legislative_proceedings"
  },
  {
    metricName: 'Social Media Share of Voice on AI',
    metricDataKey: 'publicOpinion',
    shortname_raw: 'social_media_share_of_voice_on_ai',
    shortname_scale: "norm_social_media_share_of_voice_on_ai",
    shortname_raw_pc: "pc_social_media_share_of_voice_on_ai",
    shortname_scale_pc: "norm_pc_social_media_share_of_voice_on_ai"
  },
  {
    metricName: 'AI Social Media Posts',
    metricDataKey: 'publicOpinion',
    shortname_raw: 'ai_social_media_posts',
    shortname_scale: "norm_ai_social_media_posts",
    shortname_raw_pc: "pc_ai_social_media_posts",
    shortname_scale_pc: "norm_pc_ai_social_media_posts"
  },
  {
    metricName: 'AI-Related Social Media Conversations Net Sentiment',
    metricDataKey: 'publicOpinion',
    shortname_raw: 'ai_social_media_conversations_net_sentiment',
    shortname_scale: "norm_ai_social_media_conversations_net_sentiment",
    shortname_raw_pc: "pc_ai_social_media_conversations_net_sentiment",
    shortname_scale_pc: "norm_pc_ai_social_media_conversations_net_sentiment"
  }
]

export const SUB_INDICES_INFO: SubIndicesData[] = [
  {
    indexName: 'Innovation Index',
    indexCode: 'II',
    pillarList: ['research', 'infrastructure'],
    indicators: II_SUB_INDEX_INDICATORS,
    description: "The Innovation index measures a country’s innovation potential by assessing its research and development (R&D) activities, academic output, technological advancements, intellectual property generation, and supporting technological infrastructure. It highlights a country’s capacity to produce new knowledge, innovate, and contribute to global AI advancements. The index offers insights into which countries are leading in AI development and have the necessary infrastructure to support future progress."
  },
  {
    indexName: 'Economic Competitiveness Index',
    indexCode: 'ECI',
    pillarList: ['economy'],
    indicators: ECI_SUB_INDEX_INDICATORS,
    description: "The Economic Competitiveness index measures the economic strength and market dynamism of a country in the AI sector by analyzing investment flows, talent concentration, and job creation. It captures how countries are leading in integrating AI into their economies, enhancing their competitive edge, and creating robust ecosystems for AI-driven growth."
  },
  {
    indexName: 'Policy, Governance, and Public Engagement Index',
    indexCode: 'PGPEI',
    pillarList: ['policy', 'publicOpinion'],
    indicators: PGPEI_SUB_INDEX_INDICATORS,
    description: "The Policy, Governance, and Public Engagement Index index evaluates the level of activity related to AI-related policies, legislative actions, and the broader public discourse surrounding AI. It identifies which countries are leaders in creating an enabling policy environment for AI and how public opinion is shaping the adoption and acceptance of AI technologies. Countries with a national strategy on AI and positive public sentiment are better positioned to leverage AI for national development, while those lagging may face challenges in governance, public trust, and AI deployment."
  }
]

// Removed after client's request - 
// {
//   metricName: 'AI Job Postings (% of Total)',
//   metricDataKey: 'economy',
//   shortname_raw: 'ai_job_postings_perc_of_all_job_postings',
//   shortname_scale: "norm_ai_job_postings_perc_of_all_job_postings",
//   shortname_raw_pc: "pc_ai_job_postings_perc_of_all_job_postings",
//   shortname_scale_pc: "norm_pc_ai_job_postings_perc_of_all_job_postings"
// },
